module.exports = __webpack_public_path__ + "img/leads-coin@2x.60832d1d.png";